export enum FrequencyType { 
    Occasional = 1,
    Frequent = 2
    }